import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { WarehouseReplenishmentGroupsDataGrid } from "src/components/views/erp/warehouse/masterData/WarehouseReplenishmentGroupsDataGrid.tsx";

export const Route = createFileRoute("/_authenticated/_shell/erp/warehouse/warehouseReplenishmentGroups")({
	staticData: { title: i18n.t("warehouse_replenishment_groups"), legacyViewKey: "warehouseReplenishmentGroupsPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <WarehouseReplenishmentGroupsDataGrid />;
}
